import React from "react";
import styles from "./Login.module.scss";
import { Link, Outlet } from "react-router-dom";
import { FiChevronLeft } from "react-icons/fi";
import Icon, { IconWrapper } from "components/Icon/Icon";

export default function LoginLayout(props) {
  const { children, back } = props;

  const appName = process.env.REACT_APP_NAME;
  const logo = require(`assets/images/${appName}/horizontal-logo.svg`);
  const banner = require(`assets/images/${appName}/login.jpg`);

  return (
    <div className={styles.login}>
      <div className={styles.container}>
        <main className={styles.main}>
          <div className={styles.header}>
            {back && (
              <Link className={styles.back} to={back}>
                <IconWrapper>
                  <Icon>
                    <FiChevronLeft />
                  </Icon>
                </IconWrapper>
                Voltar
              </Link>
            )}

            <img src={logo} alt="Logotipo" className={styles.logo} />
            <h1>Plataforma de ensino do Canal Educação</h1>
          </div>

          {children}

          <Outlet />
        </main>
      </div>

      <figure className={styles.figure}>
        <img src={banner} alt="imagem do banner" aria-hidden="true" className={styles.image} />
      </figure>
    </div>
  );
}
